var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"score",class:{ skelly: !_vm.init },style:(_vm.styles),on:{"click":function($event){return _vm.$emit('toggle')}}},[_vm._v(" Found: "+_vm._s(_vm.found)+" / "+_vm._s(_vm.valid)+" "),_c('span',{staticClass:"sep",attrs:{"ara-hidden":"true"}},[_vm._v("|")]),_vm._v(" Score: "+_vm._s(_vm.score)+" / "+_vm._s(_vm.max)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }